import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TsaSecurityThreatHistoryComponent } from './tsa-security-threat-history.component';
import { MVMSpinnerBtnModule } from '@max/shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { DriverTsaSecurityThreatService } from '@max/driver/services/driver-tsa-security-threat.service';
import { SharedModule } from 'primeng/api';
import { TsaSecurityThreatHistoryModalComponent } from '../tsa-security-threat-history-modal/tsa-security-threat-history-modal.component';

@NgModule({
    declarations: [
        TsaSecurityThreatHistoryComponent,
        TsaSecurityThreatHistoryModalComponent
    ],
    imports: [
        CommonModule,
        CalendarModule,
        MVMSpinnerBtnModule,
        SharedModule,
        TableModule,
        RouterModule
    ],
    providers: [
        DriverTsaSecurityThreatService
    ],
    exports: [
        TsaSecurityThreatHistoryComponent,
        TsaSecurityThreatHistoryModalComponent
    ]
})
export class TsaSecurityThreatHistoryModule {
}
